import { render, staticRenderFns } from "./CreateCategory.vue?vue&type=template&id=af81c4d4&scoped=true"
import script from "./CreateCategory.vue?vue&type=script&lang=js"
export * from "./CreateCategory.vue?vue&type=script&lang=js"
import style0 from "./CreateCategory.vue?vue&type=style&index=0&id=af81c4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af81c4d4",
  null
  
)

export default component.exports